import { render, staticRenderFns } from "./ListaCompraOptions.vue?vue&type=template&id=20059a51"
import script from "./ListaCompraOptions.vue?vue&type=script&lang=js"
export * from "./ListaCompraOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports